import styled from 'styled-components';
import Stack from '../../Stack';

export const ActionContainer = styled(Stack)`
    flex: 1 0 0;
`;
